import { render, staticRenderFns } from "./CanvasFirmaUsuario.vue?vue&type=template&id=2df965c8&scoped=true&"
import script from "./CanvasFirmaUsuario.vue?vue&type=script&lang=js&"
export * from "./CanvasFirmaUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CanvasFirmaUsuario.vue?vue&type=style&index=0&id=2df965c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df965c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
